import src from "./people.svg"

const width = 16
const height = 16
export default { src, width, height }
